<template>
  <div class="bg-white shadow-sm mx-3 my-4">
    <section class="d-flex px-3 py-2 container">
      <div class="mr-3 w-100 align-self-center">
        {{ description }}
      </div>
      <div class="align-self-center">
        <b-button
          class="py-1 px-3 w-100"
          pill
          :class="`bg-${buttonColor}`"
          :to="router"
        >
          {{ buttonText }}
        </b-button>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    description: String,
    buttonText: String,
    buttonColor: String,
    router: String
  }
};
</script>
